const translations = {
    cancel: 'Cancel',
    createMap: 'Create Map',
    flightAreaValidationError:
        'Flight area is too large, or flights are too far apart to create a map.',
    flightSprayValidationError: 'Selected flights do not contain any spray data',
    mapRequestError: 'There was an error creating the map. Please try again later.',
    mapSuccess: 'Map created successfully',
    maxNumberOfFlightsError:
        'You have more than {{maxNumberOfFlights}} flights in the group. Please reduce the number of flights to create a map.',
    multipleFlightTypesSelected:
        'You have a mix of flight types in the group. Maps can not be created with a mix of spray and spread flights',
    noMapTypesAvailable: 'Unable to create a map from these flights.',
    selectMapType: 'Select Application Map Type',
    title: 'Create Map'
};

export default translations;
